export const CREATE_NEW_GROWER = "Create new grower...";
export const CREATE_NEW_SALESPERSON = "Create new salesperson...";
export const FOLDER_TOKEN_PREFIX = "Folder Level ";
export const IS_PROD = import.meta.env.VITE_ENVIRONMENT_NAME === "production";
export const IS_DEV = import.meta.env.VITE_ENVIRONMENT_NAME === "development";
export const IS_DEV_SENTRY = import.meta.env.VITE_ENVIRONMENT_NAME === "development-sentry";
export const DEBUG = IS_DEV || IS_DEV_SENTRY || import.meta.env.VITE_DEBUG === "true";
export const INVALID_USERCONTEXT = "Authentication error. Try logging out and back in.";
export const DEFAULT_PAGE: string = "/home";
